// extracted by mini-css-extract-plugin
export var body = "_dj-5";
export var closeButton = "_dj-f";
export var container = "_dj-1";
export var content = "_dj-2";
export var cta = "_dj-c";
export var ctaLabel = "_dj-b";
export var eyebrow = "_dj-3";
export var howTo = "_dj-6";
export var image = "_dj-e";
export var modal = "_dj-0";
export var socialButton = "_dj-d";
export var stepCard = "_dj-8";
export var stepLabel = "_dj-a";
export var stepNumber = "_dj-9";
export var steps = "_dj-7";
export var title = "_dj-4";